import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import routes from "../../../assets/apiRoutes.json"
import {DateBox} from 'devextreme-react/date-box';
import {RadioGroup} from 'devextreme-react/radio-group';
import {Button} from 'devextreme-react/button';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import { confirm } from 'devextreme/ui/dialog';
import { Popup } from 'devextreme-react/popup';
import Form, {SimpleItem, Label} from 'devextreme-react/form';
import { GridLayout } from "../../../common/GridLayout";
import { handleDataGridExport } from "../../../common/Utils";

import DataGrid, {
  Column,
  Editing,
  Paging,
  Pager,
  FilterRow,
  FilterPanel,
  FilterBuilderPopup,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnFixing,
  Sorting,
  Export,
  HeaderFilter,
  StateStoring
} from 'devextreme-react/data-grid';

import { createStore } from 'devextreme-aspnet-data-nojquery';
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";

const filterBuilderPopupPosition = {
  of: window,
  at: 'top',
  my: 'top',
  offset: { y: 10 },
};

const dataGrid = React.createRef();
let accessToken = '';
function renderStratCompleteHeaderLabel() {
  return <p className="main-title" style={{marginTop: '18px'}}>Strat Complete</p>;
}

 const dayViews = [
  { id: -7, text: '7 Day View' },
  { id: -14, text: '14 Day View' },
  { id: -21, text: '21 Day View' }
];

const gridKey = "8a905e49-da10-4ec7-9314-ebe8d3746c30";
class StratComplete extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedDayView: dayViews[0].id,
      completeDate :  new Date(),
      popupVisible : false,
      cutLot : {
        rowid: "00000000-0000-0000-0000-000000000000",
        newwetweight: 0.0,
        lotcutdate: new Date(),
        newbags: 0,
        newseedslb: 0,
        fieldname: ""
      },
      currentLayout: "Default",
    };

    accessToken = props.oidc.user.access_token;
    this.onContentReady = this.onContentReady.bind(this);
    this.onChangeDayView = this.onChangeDayView.bind(this);
    this.setDryStratCompleteValue = this.setDryStratCompleteValue.bind(this);
    this.onCompleteDateChanged = this.onCompleteDateChanged.bind(this);
    this.processButtonClicked = this.processButtonClicked.bind(this);
    this.hidePopup = this.hidePopup.bind(this);
    this.popupOKClick = this.popupOKClick.bind(this);
    this.formFieldChanged = this.formFieldChanged.bind(this);
    var that = this;

    this.dataSource = createStore({
      key: 'rowid',
      loadParams:
      {
        dayView: function ()
        {
          return that.state.selectedDayView;
        }
      },
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.stratcomplete.AllStratCompletes}`,
      updateUrl: `${window._env_.REACT_APP_APIS}/${routes.stratcomplete.UpdateStratComplete}`,
      onBeforeSend: function(method, ajaxOptions) {
        ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        };
      }
    });
  }
  setCurrentLayout =(value)=>{
    this.setState({
      currentLayout:value
    })
  }
  loadState = () => {return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null, this.state.currentLayout);}
  saveState=(state)=> { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, this.state.currentLayout);}
  render() {
    return (
      <div className="h-100"  style={{ overflowY: 'hidden' }}>
        <div
  style={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    backgroundColor: 'rgb(240, 241, 239)',
    padding: '10px',
    flexWrap: 'wrap',
    gap: '20px'
  }}
>
  {/* Title on the left */}
  <h6
    style={{
      color: window._env_.Color2,
      margin: 0
    }}
  >
    Strat Complete
  </h6>

  {/* Controls on the right */}
  <div
    style={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: '10px',
      flexWrap: 'wrap'
    }}
  >
    <DateBox
      type="date"
      value={this.state.completeDate}
      onValueChanged={this.onCompleteDateChanged}
    />

    <RadioGroup
      items={dayViews}
      value={this.state.selectedDayView}
      valueExpr="id"
      displayExpr="text"
      layout="horizontal"
      onValueChanged={this.onChangeDayView}
    />

    <Button
      text="Process Order"
      type="default"
      onClick={this.processButtonClicked}
    />
  </div>
</div>

        <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }} id="gridContainer"
          onContentReady={this.onContentReady}
          onCellPrepared={this.onCellPrepared}
          
          ref={dataGrid}
          showBorders={true}
          className="SO_StartCompleteGridStyle"
          rowAlternationEnabled={true}
          allowColumnReordering={true}
          columnAutoWidth={true}
        >
          <Paging
            enabled={false}
          />
          <Pager
            visible={true}
            showPageSizeSelector={false}
            showNavigationButtons={false}
            showInfo={true}
            infoText="({2} items)"
          />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <FilterBuilderPopup position={filterBuilderPopupPosition} />
          <ColumnChooser
            enabled={true}
            title="Choose Column"
            width={290}
            height={290}
            sortOrder="asc"
          >
            <ColumnChooserSearch
              enabled={true}
              editorOptions={{ placeholder: 'Search column' }} />
          </ColumnChooser>
          <HeaderFilter visible={true} />
          <ColumnFixing enabled={true}/>,
          <Export enabled={true} allowExportSelectedData={true} text="Export" />
          <Sorting mode="multiple"/>
          <Editing
            mode="cell"
            refreshMode="reshape"
            allowUpdating={true}
            allowAdding={false}
            allowDeleting={false} />
          <StateStoring
            enabled={true}
            type="custom"
            customLoad={this.loadState}
            storageKey={gridKey}
            customSave={this.saveState}
          />
          <Column dataField="drystratcomplete" dataType="boolean" caption="" setCellValue={this.setDryStratCompleteValue}/>
          <Column dataField="drystratcompletedate" dataType="date" caption="Strat Complete" allowEditing={false}/>
          <Column dataField="drystratdonedate" caption="Strat Out Date"  dataType="date"  allowEditing={false} cssClass="column-readonly"/>
          <Column dataField="species" caption="Species" allowEditing={false} cssClass="column-readonly"/>
          <Column dataField="prodlot" caption="Production Lot" allowEditing={false} cssClass="column-readonly"/>
          <Column dataField="celltype" caption="Stock" allowEditing={false} cssClass="column-readonly"/>
          <Column dataField="facility" caption="Facility" allowEditing={false} cssClass="column-readonly"/>
          <Column dataField="color" caption="Color" allowEditing={false} cssClass="column-readonly"/>
          <Column dataField="symbol" caption="Symbol" allowEditing={false} cssClass="column-readonly"/>
          <Column dataField="iscut" caption="Cut" allowEditing={false} cssClass="column-readonly"/>
          <Toolbar>
          <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={this.setCurrentLayout} />
                 </Item>
            <Item name="exportButton" />
            <Item name="columnChooserButton" />
          </Toolbar>
        </DataGrid>
        <Popup
          visible={this.state.popupVisible}
          onHiding={this.hidePopup}
          dragEnabled={false}
          hideOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          title="E-Germ Info Missing"
          container=".dx-viewport"
          closeOnOutsideClick={true}
          width={500}
          height={400}
        >
         <Form
            id="cutLotForm"
            labelMode="static"
            labelLocation="left"
            formData={this.state.cutLot}
            minColWidth={100}
            colCount={1}
            onFieldDataChanged={this.formFieldChanged}>
              <SimpleItem dataField="newwetweight"><Label text="New Net Weight"></Label></SimpleItem>
              <SimpleItem dataField="lotcutdate"><Label text="Lot Cut Date"></Label></SimpleItem>
              <SimpleItem dataField="newbags"><Label text="New Bags"></Label></SimpleItem>
              <SimpleItem dataField="newseedslb"><Label text="New Seeds LB"></Label></SimpleItem>
          </Form>
          <div>
            <Button text="OK" type="default" onClick={this.popupOKClick}></Button>
          </div>
        </Popup>
      </div>
    );
  }

  formFieldChanged(e) 
  {
    var that = this;
    this.state.cutLot.fieldname = e.dataField;
    axios.put
    (
      `${window._env_.REACT_APP_APIS}/${routes.stratcomplete.InsertUpdateCutLot}`,
      this.state.cutLot,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: accessToken,
        },
      }
    )
    .then((res) => 
    {
      let rows =  dataGrid.current.instance().getVisibleRows();  
      let rowIndex = dataGrid.current.instance().getRowIndexByKey(that.state.cutLot.rowid);  
      let row = rows[rowIndex];
      switch(e.dataField)
      {
        case "newwetweight":
          row.data.newwetweight = that.state.cutLot.newwetweight;
          break;
        case "lotcutdate":
          row.data.lotcutdate = that.state.cutLot.lotcutdate;
            break;
        case "newbags":
          row.data.newbags = that.state.cutLot.newbags;
          break;
        case "newseedslb":
          row.data.newseedslb = that.state.cutLot.newseedslb;
          break;
      }

    })
    .catch((err) => {
      alert(err, "Error");
    });
  }

  popupOKClick()
  {
    this.hidePopup();
  }

  hidePopup() {
    this.setState({
      popupVisible: false
    });
  }

  onContentReady(e) {
    if (!e.component._hasLoaded) {
      e.component._hasLoaded = true;
      e.component.option("dataSource", this.dataSource);
    }
  }

  onCellPrepared = (e) => {
    if(e.rowType === "data" && e.column.dataField === "prodlot" && e.data.iscut === "Yes") {
        e.cellElement.style.backgroundColor = "#FFFF66";
    }
}

  onCompleteDateChanged(e) {
    this.setState({
      completeDate: e.value,
    });
  }
  
  onChangeDayView(e)
  {
    this.setState({
      selectedDayView : e.value,
    });

    dataGrid.current.instance().refresh();

  }

  setDryStratCompleteValue(newData, value, currentRowData) {
    
    if(currentRowData.iscut === "Yes" && (currentRowData.newwetweight === null || currentRowData.newbags === null || currentRowData.newseedslb === null) || (currentRowData.newwetweight === 0 || currentRowData.newbags === 0 || currentRowData.newseedslb === 0))
    {
      var cutLot = {...this.state.cutLot}
      cutLot.rowid = currentRowData.rowid;
      cutLot.lotcutdate = currentRowData.lotcutdate;
      cutLot.newwetweight = currentRowData.newwetweight;
      cutLot.newbags = currentRowData.newbags;
      cutLot.newseedslb = currentRowData.newseedslb;
      this.setState({cutLot});
      this.setState({
        popupVisible: true
      });
    }
    else
    {
      var rowIndex = dataGrid.current.instance().getRowIndexByKey(currentRowData.rowid);
      if(value)
      {
        dataGrid.current.instance().cellValue(rowIndex, "drystratcompletedate", this.state.completeDate);
      }
      else
      {
        dataGrid.current.instance().cellValue(rowIndex, "drystratcompletedate", "");
      }

      dataGrid.current.instance().saveEditData();
    }
  }

  processButtonClicked()
  {
    var that = this;
    let result = confirm("<i>Process Strat Completion?</i>", "Process Order");
    result.then((dialogResult) => {
        if(dialogResult)
        {
          dataGrid.current.instance().beginCustomLoading("Processing");
          axios.put
          (
            `${window._env_.REACT_APP_APIS}/${routes.stratcomplete.ProcessOrders}`,
            null,
            {
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
              },
            }
          )
          .then((res) => {
            dataGrid.current.instance().endCustomLoading();
            dataGrid.current.instance().refresh();
          })
          .catch((err) => {
            dataGrid.current.instance().endCustomLoading();
            alert(err, "Error");
          });

        }
    });

  }
}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(StratComplete);
